var $b9c2d9e9562cfc18$exports = {};
(function() {
    function angleToRadians(angle) {
        return Math.PI / 180 * angle;
    }
    var canvas = document.getElementById("canvas");
    var context = canvas.getContext("2d");
    var widthCanvas = 500;
    var renderRandomCircle = function(widthCanvas) {
        context.beginPath();
        context.fillStyle = "rgb(".concat(Math.random() * 255, ", ").concat(Math.random() * 255, ", ").concat(Math.random() * 255, ")");
        var positionX = Math.random() * widthCanvas;
        var positionY = Math.random() * widthCanvas;
        var radius = Math.random() * 100;
        var startAngle = angleToRadians(0);
        var endAngle = angleToRadians(360);
        var counterclockwise = true;
        context.arc(positionX, positionY, radius, startAngle, endAngle, counterclockwise);
        context.fill();
        context.closePath();
    };
    var renderAnimateCircle = function(endAngleControl) {
        var startAngle = angleToRadians(180);
        var counterclockwise = false;
        var radius = 50;
        var endAngle = angleToRadians(endAngleControl);
        context.beginPath();
        context.fillStyle = "#0aa";
        context.arc(200, 200, radius, startAngle, endAngle, counterclockwise);
        context.fill();
        context.closePath();
        context.beginPath();
        context.fillStyle = "#faa";
        context.arc(200, 200, radius, startAngle, endAngle, !counterclockwise);
        context.fill();
        context.closePath();
    };
    var quantitySpheres = 50;
    var endAngleControl = 0;
    function draw() {
        setTimeout(function() {
            context.clearRect(0, 0, 500, 500);
            for(var index = 0; index < quantitySpheres; index += 1)renderRandomCircle(widthCanvas);
            renderAnimateCircle(endAngleControl);
            endAngleControl += 1;
            if (endAngleControl > 360) endAngleControl = 0;
            requestAnimationFrame(draw);
        }, 800);
    }
    draw();
})();


//# sourceMappingURL=circle.fbca4612.js.map
